/** @file Emits a filled disc (12-segment triangle fan) of a given pixel radius. */
import type { Sink } from './createSink';
import { emitMesh, type PixelMesh } from './emitMesh';
import { unitCircle } from './unitCircle';

const SEGMENTS = 12;
const xy = new Float64Array(2 * (SEGMENTS + 1));
/** Fan indices: centre 0, rim 1..SEGMENTS. */
const FAN = Array.from({ length: SEGMENTS }, (_, i) => [0, 1 + i, 1 + ((i + 1) % SEGMENTS)]).flat();
/** cos / sin of the rim angles, through trig once (the same values every call computed). */
const [COS, SIN] = unitCircle(SEGMENTS);
/** The primitive, refilled per call (no object per disc). */
const mesh: PixelMesh = { page: 0, count: SEGMENTS + 1, xy, uv: null, light: 0, lights: null, indices: FAN };

/** Centre (cx, cy) and radius in pixels. */
export function emitDisc(sink: Sink, cx: number, cy: number, radius: number, light: number): void {
  xy[0] = cx;
  xy[1] = cy;
  for (let i = 0; i < SEGMENTS; i++) {
    xy[2 + 2 * i] = cx + radius * (COS[i] ?? 0);
    xy[3 + 2 * i] = cy + radius * (SIN[i] ?? 0);
  }
  mesh.page = sink.white;
  mesh.light = light;
  emitMesh(sink, mesh);
}
